// extracted by mini-css-extract-plugin
export default {"Slct":"Slct_Slct__cBd8p","Slct_multi":"Slct_Slct_multi__ee4uZ"};